import moment from "moment";
import { DropDownChoice } from "../../../../types/components/dropdown";
import { DomusoPropertyProfile, RewardsLedgerItem } from "../../../../types/db-types";
import { RewardsType } from "../../../enums";
import { RewardsData } from "../../../redux/reducers/reward";

export const accountTypeDropdownChoices: DropDownChoice[] = [
  { label: "Checking", value: "Checking", dbValue: "CHECKING" },
  { label: "Savings", value: "Savings", dbValue: "SAVINGS" },
  { label: "Corporate Checking", value: "Corporate", dbValue: "CORPORATE" },
  { label: "Corporate Savings", value: "Corporate Savings", dbValue: "CORP_SAVINGS" },
];

export const dbToAccountTypeFieldValueMapping = (dbValue?: string) => {
  let accountTypeLabel = null;
  for (let accountType of accountTypeDropdownChoices) {
    if (accountType?.dbValue === dbValue) {
      accountTypeLabel = accountType?.label;
      break;
    }
  }
  return accountTypeLabel;
};

export const getPropertyAddressFromPropertyProfile = (property_profile: DomusoPropertyProfile) => {
  const { postal_code, street_address, city, state } = property_profile;
  return [street_address, city, state, postal_code].join(" ");
};

export const deriveUnitTitle = (property_unit: string | number | null) => {
  return `Unit ${getUnitNumber(property_unit)}`;
};

export const getUnitNumber = (property_unit: string | number | null) => {
  if (property_unit) {
    return `#${property_unit}`;
  }
  return `Unassigned`;
};
export const getRewardByRewardType = (rewardsData: RewardsData, rewardType: RewardsType) =>
  rewardsData?.ledger_items?.find((x: any) => x?.type === rewardType);

export const formatNumberWithCommas = (number?: number | string) => {
  return number ? Number(number).toLocaleString() : "0";
};

export const formatDate = (d: Date | undefined, format?: string) =>
  d && moment(d).format(format || "M/D/YY");

interface SplitPendingAndEarnedItems {
  pending: RewardsLedgerItem[];
  earned: RewardsLedgerItem[];
}
export const filterPendingAndEarnedRewards = (rewardsData: RewardsData, type: RewardsType) => {
  return rewardsData?.ledger_items?.slice()?.reduce<SplitPendingAndEarnedItems>(
    (acc, item) => {
      if (item.type === type) {
        const redeemedAt = item?.redeemed_at
          ? new Date(item?.redeemed_at?.split("T")[0]?.replaceAll("-", "/"))
          : null;
        const currentDate = moment().startOf("day").toDate();
        if (redeemedAt == null || redeemedAt > currentDate) {
          acc.pending.push(item);
        } else if (redeemedAt && redeemedAt <= currentDate) {
          acc.earned.push(item);
        }
      }
      return acc;
    },
    { pending: [], earned: [] }
  );
};
